<div class="padding">
  <mat-card>
    <mat-card-content>
      <div class="table-container">
        <div class="flex-container-space-between">
          <h3>{{ 'envelopes.envelopesOverview' | transloco }}</h3>
        </div>

        <!-- Databases overview table -->
        @if ((this.repo.resourceCount$ | async) ?? 0 > 0) {
          <table mat-table [dataSource]="this.repo.resource$" multiTemplateDataRows
            >
            <ng-container matColumnDef="logs">
              <th mat-header-cell *matHeaderCellDef id="logs"> </th>
              <td mat-cell *matCellDef="let envelope">
                <div class="flex-container-center">
                  <a mat-flat-button color="primary" (click)="viewLogs(envelope)">
                    {{ 'common.labels.logs' | transloco }}
                  </a>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="added">
              <th mat-header-cell *matHeaderCellDef id="added">
                <div class="flex-container-center">
                  {{ 'envelopes.creationDate' | transloco }}
                </div>
              </th>
              <td mat-cell *matCellDef="let envelope">
                <div class="flex-container-center">
                  {{ envelope.added | localizedDate }}
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="numOrders">
              <th mat-header-cell *matHeaderCellDef id="numOrders">
                <div class="flex-container-center">
                  {{ 'common.labels.orders' | transloco }}
                </div>
              </th>
              <td mat-cell *matCellDef="let envelope">
                <div class="flex-container-center">
                  <a mat-flat-button color="primary" (click)="viewOrders(envelope)">
                    {{ envelope.envelopeOrders.length }}
                  </a>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="previous">
              <th mat-header-cell *matHeaderCellDef id="previous"> </th>
              <td mat-cell *matCellDef="let envelope">
                <div class="flex-container-center">
                  <a mat-flat-button color="primary" [disabled]="!envelope.envelopeStatus.isPreviousAvailable || isProcessing(envelope)" (click)="previous(envelope)">
                    {{ envelope.envelopeStatus.previousActionName ?? ('common.labels.prev' | transloco) }}
                  </a>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="icon">
              <th mat-header-cell *matHeaderCellDef id="icon"> </th>
              <td mat-cell *matCellDef="let envelope">
                <div class="flex-container-center">
                  @if (!isProcessing(envelope)) {
                    <mat-icon>{{ getIcon(envelope) }}</mat-icon>
                  } @else {
                    <div class="spinner-inline-container">
                      <div class="spinner-inline"> </div>
                    </div>
                  }
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef id="status">
                <div class="flex-container-center">
                  {{ 'common.labels.status' | transloco }}
                </div>
              </th>
              <td mat-cell *matCellDef="let envelope">
                <div class="flex-container-center">
                  @if (!isProcessing(envelope)) {
                    <span>{{ envelope.envelopeStatus.id }}</span>
                  } @else {
                    <span>{{ 'envelopes.processing' | transloco }}</span>
                  }
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="next">
              <th mat-header-cell *matHeaderCellDef id="next"> </th>
              <td mat-cell *matCellDef="let envelope">
                <div class="flex-container-center">
                  <a mat-flat-button color="primary" [disabled]="!envelope.envelopeStatus.isNextAvailable || isProcessing(envelope)" (click)="next(envelope)">
                    {{ envelope.envelopeStatus.nextActionName ?? ('common.buttons.next' | transloco) }}
                  </a>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="updateState">
              <th mat-header-cell *matHeaderCellDef id="updateState">
                <div class="flex-container-center">
                  {{ 'envelopes.manageState' | transloco }}
                </div>
              </th>
              <td mat-cell *matCellDef="let envelope">
                <div class="custom-select-container">
                  <select class="custom-select" id="statusUpdateSelect" class="form-control" (change)="onStatusUpdateChange($event, envelope)">
                    <option> </option>
                    <option value="Open">{{ 'envelopes.open' | transloco }}</option>
                    <option value="Sealed">{{ 'envelopes.sealed' | transloco }}</option>
                    <option value="Imported">{{ 'envelopes.imported' | transloco }}</option>
                    <option value="ResultsPending">{{ 'envelopes.resultspending' | transloco }}</option>
                    <option value="Complete">{{ 'envelopes.complete' | transloco }}</option>
                  </select>
                  <button mat-icon-button color="primary" (click)="saveStatus(envelope)"><mat-icon>save</mat-icon></button>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="document">
              <th mat-header-cell *matHeaderCellDef id="document">
                <div class="flex-container-center">
                  {{ 'common.labels.document' | transloco }}
                </div>
              </th>
              <td mat-cell *matCellDef="let envelope">
                <div class="flex-container-center">
                  <a mat-flat-button color="primary" (click)="downloadDocument(envelope)"
                  [disabled]="!envelope.document">{{ 'common.buttons.download' | transloco }}</a>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        }

        @if ((repo.resourceCount$ | async) ?? 0 > pageSize) {
          <mat-paginator [hidePageSize]="true"
            [pageSize]="pageSize" [length]="this.repo.resourceCount$ | async"
            [pageIndex]="this.repo.pageNum$ | async" showFirstLastButtons="true"
          (page)="page($event)"></mat-paginator>
        }
      </div>
    </mat-card-content>
  </mat-card>
</div>